/**
 * Render wishlist icon on product tile
 *
 * @param {Object} product - product flags
 * @param {string} wishlistLink - wishlist url for add/delete
 * @returns {string} product flags HTML
 */
export default (product, wishlistLink) => `
${
    SitePreferences.ENABLE_WISHLIST_CLP_AND_REC
        ? `
        <div class="product-wishlist">
            <button
                class="product-wishlist-link js-favorite ${product.isInWishlist ? 'in-wishlist' : 'not-in-wishlist'}"
                data-href="${wishlistLink}"
                data-pid="${product.ID}"
                data-source="plp"
                data-cnstrc-btn="add_to_wishlist"
                >
                <i aria-hidden="true" class="icon ${
                    product.isInWishlist ? 'icon-wishlist-active' : 'icon-wishlist'
                }"><!-- icon --></i>
            </button>
        </div>`
        : ''
}
`;
